import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * ChangePasswordView class for handling password change functionality.
 */
export default class changePasswordView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Configuration for the left section containing the new password input
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for new password
                    name: 'NewPassword',
                    type: 'password',
                    id: 'NewPassword',
                    label: _('Nueva Contraseña'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Nueva Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _(
                        'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.',
                    ), // Error message for invalid input
                    validate: function (value) {
                        // Validation function for password strength
                        return value.length >= 8 && /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value);
                    },
                    on: {
                        onBlur: function () {
                            // Validate on blur event
                            $$('NewPassword').validate();
                        },
                    },
                },
            ],
        };

        // Configuration for the right section containing the confirm password input
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for confirming password
                    name: 'ConfirmPassword',
                    type: 'password',
                    id: 'ConfirmPassword',
                    label: _('Confirmar Contraseña'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Confirmar Contraseña'), // Placeholder text
                    required: true, // Field is required
                    invalidMessage: _('Contraseñas no coinciden'), // Error message for mismatched passwords
                    validate: function (value) {
                        // Validation function for confirming password
                        return value == $$('NewPassword').getValue();
                    },
                    on: {
                        onBlur: function () {
                            // Validate on blur event
                            $$('ConfirmPassword').validate();
                        },
                    },
                },
            ],
        };

        // Upper section layout combining left and right sections
        const upper_section = {
            cols: [
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button configuration for form actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        // Clear form values and validation
                        $$('formChangePassword').setValues($$('formChangePassword').getCleanValues());
                        $$('formChangePassword').clearValidation();
                    },
                },
                {
                    view: 'button', // Save button
                    value: _('Guardar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Handle save action
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newPassword = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('user', true); // Get current user parameter
                            if (
                                newPassword.NewPassword === newPassword.ConfirmPassword // Check if passwords match
                            ) {
                                webix.confirm({
                                    // Confirmation dialog for changing password
                                    type: 'confirm-warning',
                                    text: 'Advertencia!<br/>Desea cambiar la contraseña?',
                                    ok: 'Cambiar Contraseña',
                                    cancel: 'Salir',
                                    callback: function (action) {
                                        // Callback for confirmation action
                                        if (action === true) {
                                            const data = {
                                                FromId: cur_user, // User ID
                                                NewPassword: newPassword.NewPassword, // New password
                                                ConfirmPassword: newPassword.ConfirmPassword, // Confirm password
                                            };
                                            webix
                                                .ajax() // AJAX request to change password
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(devConfig.geturlApi() + 'AgentList/ChangePassword', data, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error handling
                                                        webix.message('Error');
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success handling
                                                        var json = JSON.parse(text);
                                                        if (json.HasError) {
                                                            // Check for errors in response
                                                            if (json.CodeError != 110012) {
                                                                webix.message({
                                                                    text: json.AlertMessage,
                                                                    title: '¡Error!',
                                                                    type: 'alert-error',
                                                                });
                                                            }
                                                        } else {
                                                            webix.message({
                                                                text: 'Contraseña cambiada satisfactoriamente', // Success message
                                                                title: '¡Exito!',
                                                                type: 'alert-warning',
                                                            });
                                                            $$('formChangePassword').setValues(
                                                                $$('formChangePassword').getCleanValues(),
                                                            );
                                                            $$('formChangePassword').clearValidation(); // Clear form after success
                                                        }
                                                    },
                                                });
                                        }
                                    },
                                });
                            } else {
                                webix.message({
                                    // Error message for mismatched passwords
                                    title: '¡Error!',
                                    type: 'alert-error',
                                    text: 'Contraseñas no coinciden',
                                });
                            }
                        } else {
                            webix.message({
                                // Error message for incomplete form
                                title: '¡Error!',
                                type: 'alert-error',
                                text: 'Completa los campos...',
                            });
                        }
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            id: 'formChangePassword', // Form ID
            rows: [upper_section, buttons], // Form layout
        };
    }
}

// FILE DOCUMENTED
